<template>
  <div v-if="hasCommunity" class="telegram-community-card pt-5">
    <h5 class="page-title mb-3">Comunidade no Telegram</h5>

    <div
      class="community-card d-flex flex-column flex-sm-row align-items-start align-items-sm-center p-3"
    >
      <img
        :src="telegramIcon"
        alt="Telegram"
        class="community-icon mb-3 mb-sm-0 mr-sm-3"
      />

      <div class="community-info flex-fill">
        <p v-if="groupNames" class="community-groups mb-1">{{ groupNames }}</p>
        <p class="community-note mb-0">
          Você será direcionado ao Telegram. A entrada é liberada
          automaticamente.
        </p>
      </div>

      <a
        :href="community.deep_link"
        target="_blank"
        rel="noopener"
        class="btn btn-community mt-3 mt-sm-0 ml-sm-3"
      >
        Entrar na comunidade
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import telegramIcon from "@/assets/images/telegram.png";

export default {
  name: "TelegramCommunityCard",
  data() {
    return {
      telegramIcon
    };
  },
  computed: {
    ...mapState("telegram", ["community"]),
    ...mapGetters("telegram", ["hasCommunity"]),
    groupNames() {
      const groups = (this.community && this.community.groups) || [];

      return groups
        .map(group => group.title)
        .filter(title => title)
        .join(" · ");
    }
  }
};
</script>

<style lang="scss" scoped>
.telegram-community-card {
  .community-card {
    border: 1px solid rgba(119, 120, 142, 0.3);
    border-radius: 8px;
  }

  .community-icon {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }

  .community-groups {
    font-size: 14px;
    font-weight: 600;
    line-height: 150%;
  }

  .community-note {
    font-size: 12px;
    line-height: 150%;
    color: var(--verso-dark-grey-1, #bebfc7);
  }

  .btn-community {
    background-color: #229ed9;
    border-color: #229ed9;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;

    &:hover,
    &:focus {
      background-color: #1c87ba;
      border-color: #1c87ba;
      color: #fff;
    }
  }
}
</style>
